import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonItem, IonIcon, IonCard, IonCardContent, IonLabel, IonToggle } from '@ionic/react'
import { moonOutline } from 'ionicons/icons'

const Settings = () => {
    const toggleDarkModeHandler = () => {
        document.body.classList.toggle("dark");
    };
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        Settings
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonCard>
                    <IonCardContent>
                        <IonItem>
                            <IonIcon icon={moonOutline} slot="start" />
                            <IonLabel>Dark Mode</IonLabel>
                            <IonToggle slot="end" name="darkMode" mode="ios" color="success" onIonChange={toggleDarkModeHandler} />
                        </IonItem>
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    )
}

export default Settings
